<div class="kapea" [class.service-enabled]="viewState() === 'enabled'">
  <div class="center-container">
    <div class="settings-container">
      <button mat-button class="secondarybutton" (click)="editAddress()">{{ 'tositteet.laskujen-vastaanotto.asetukset' | translate | async }}</button>
    </div>

    <h2 class="title">{{ 'tositteet.laskujen-vastaanotto.vastaanotto-ja-valityspalvelu' | translate | async }}</h2>

    @if (viewState() === 'not-enabled') {
      <div class="text-part">
        <p>{{ 'tositteet.laskujen-vastaanotto.voit-vastaanottaa-laskuja' | translate | async }}</p>
        <p>{{ 'tositteet.laskujen-vastaanotto.valityspalvelu-on-ilmaista' | translate | async }}</p>
      </div>
      <div class="lisaa-nappula-container">
        <button mat-button (click)="editAddress()" type="button" class="primarybutton">
          {{ 'tositteet.laskujen-vastaanotto.ota-kayttoon' | translate | async }}
        </button>
      </div>
    }

    @if (viewState() === 'edit-address') {
      <div>
        <form style="margin: 20px">
          <mat-slide-toggle aria-label="Aktivoi palvelu" style="transform: scale(1.2); font-size: 12px; margin: 0 60px 50px; text-align: left" [formField]="serviceActive">{{ 'tositteet.laskujen-vastaanotto.aktivoi-palvelu' | translate | async }}</mat-slide-toggle>
          <div class="text-part">
            {{ 'tositteet.laskujen-vastaanotto.ennen-palvelun-kayttoonottoa' | translate | async }}
          </div>
          <div style="text-align: left">
            <mat-form-field>
              <mat-label>{{ 'tositteet.laskujen-vastaanotto.valittaja' | translate | async }}</mat-label>
              <mat-select [formField]="valittaja">
                @for (operator of operaattorit; track operator) {
                  <mat-option [value]="operator.tunnus"> {{ operator.nimi }} ({{ operator.tunnus }}) </mat-option>
                }
              </mat-select>
              @if (onkoVirhe(valittaja, 'required') && (valittaja().dirty() || valittaja().touched())) {
                <mat-error>
                  {{ 'tositteet.laskujen-vastaanotto.valittaja-required' | translate | async }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'tositteet.laskujen-vastaanotto.osoite' | translate | async }}</mat-label>
              <input type="text" [formField]="osoite" matInput data-lpignore="true" />
              @if (onkoVirhe(osoite, 'required') && (osoite().dirty() || osoite().touched())) {
                <mat-error>
                  {{ 'tositteet.laskujen-vastaanotto.osoite-required' | translate | async }}
                </mat-error>
              }
            </mat-form-field>
            <mat-checkbox [formField]="forwardLemontreeLaskut" class="pitka-label" style="margin-top: 1.5em">
              {{ 'tositteet.laskujen-vastaanotto.haluan-myos-lemon-treen-laskut' | translate | async }}
            </mat-checkbox>
            <mat-checkbox [formField]="forwardRequiresApproving" class="pitka-label" style="margin-top: 1em; margin-bottom: 1.5em">
              {{ 'tositteet.laskujen-vastaanotto.haluan-hyvaksya' | translate | async }}
            </mat-checkbox>
          </div>
        </form>
        @if (commonError()) {
          <div class="lemon-error">{{ commonError() }}</div>
        }
        @if (noApixAddressYet()) {
          <div class="button-container">
            <button mat-button (click)="saveAddress()" type="button" class="primarybutton">
              {{ 'yleiset.jatka' | translate | async }}
            </button>
          </div>
        } @else {
          <div class="button-container">
            <button mat-button (click)="backToEnabledView()" type="button" class="secondarybutton">
              {{ 'yleiset.peruuta' | translate | async }}
            </button>
            <button [disabled]="!serviceActive().value()" mat-button (click)="saveAddress()" type="button" class="primarybutton">
              {{ 'yleiset.tallenna' | translate | async }}
            </button>
          </div>
        }
      </div>
    }

    @if (viewState() === 'enabled') {
      <div class="enabled-sign">
        <i class="fa fa-check green-text" aria-hidden="true" style="margin-right: 0.5em"></i>
        <span style="color: #767676">{{ 'tositteet.laskujen-vastaanotto.aktiivinen' | translate | async }}</span>
      </div>
      <div class="text-part">
        @if (laskujenHyvaksyntaActiveObservable | async) {
          <div>
            <p>{{ 'tositteet.laskujen-vastaanotto.osoite-tallennettu-hyvaksynta-valittu' | translate | async }}</p>
            <!-- <span class="link-like" (click)="editAddress()">{{'tositteet.laskujen-vastaanotto.tarkastele-osoitetta' | translate | async}}</span> -->
          </div>
        } @else {
          <p>{{ 'tositteet.laskujen-vastaanotto.osoite-tallennettu-ei-hyvaksyntaa' | translate | async }}</p>
          <!-- <span class="link-like" (click)="editAddress()">{{'tositteet.laskujen-vastaanotto.tarkastele-osoitetta' | translate | async}}</span> -->
        }
        <p>{{ 'tositteet.laskujen-vastaanotto.alta-loydat' | translate | async }}</p>
        @if (apixLaskuosoiteObservable | async; as apixLaskuosoite) {
          <div class="osoite-info">
            <div>{{ 'tositteet.laskujen-vastaanotto.verkkolaskuosoite' | translate | async }}: {{ apixLaskuosoite.sahkoinenOsoite }}</div>
            <div>{{ 'tositteet.laskujen-vastaanotto.valittaja' | translate | async }}: {{ apixLaskuosoite.sahkoinenValittajaNimi ? apixLaskuosoite.sahkoinenValittajaNimi + ' (' + apixLaskuosoite.sahkoinenValittaja + ')' : apixLaskuosoite.sahkoinenValittaja }}</div>
          </div>
        }
        <div>
          {{ 'tositteet.laskujen-vastaanotto.voit-myos-antaa' | translate | async }} <span class="link-like" (click)="downloadPdf()">{{ 'tositteet.laskujen-vastaanotto.lataa-pdf' | translate | async }}</span>
        </div>
      </div>
    }

    <div lemon-loading [show]="!viewState()"></div>
  </div>
</div>
